



import { useState } from "react";
import { Search } from "lucide-react";
import OrderCard from "../components/modules/orders/OrderCard";
import ordersData from "../data/ordersData";

const filters = ["All", "Awaiting Payment", "In Production", "Quality Inspection", "Delivered"];

export default function Orders() {
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = ordersData.filter((o) => {
    const matchesFilter = activeFilter === "All" || o.deliveryStatus === activeFilter;
    const matchesQuery =
      o.projectTitle.toLowerCase().includes(query.toLowerCase()) ||
      o.id.toLowerCase().includes(query.toLowerCase());
    return matchesFilter && matchesQuery;
  });

  const activeCount = ordersData.filter((o) => o.deliveryStatus !== "Delivered").length;
  const totalSpend = ordersData
    .filter((o) => o.paymentStatus === "Paid")
    .reduce((sum, o) => sum + o.amount, 0);

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
      <p className="text-gray-600 mt-1 mb-6">
        Track payments and delivery status for your confirmed builds.
      </p>

      {/* Summary stats */}
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL ORDERS</p>
          <p className="text-2xl font-extrabold text-gray-900">{ordersData.length}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE ORDERS</p>
          <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
          <p className="text-2xl font-extrabold text-gray-900">
            ₹{totalSpend.toLocaleString("en-IN")}
          </p>
        </div>
      </div>

      {/* Search + filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6" style={{display:"flex", justifyContent:"space-between"}}>
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by project name or order ID..."
            className="w-full bg-transparent text-sm focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {filters.map((f) => {
            const isActive = activeFilter === f;
            return (
              <button
                key={f}
                type="button"
                onClick={() => setActiveFilter(f)}
                className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                  isActive
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>

      {/* List */}
      {filtered.length > 0 ? (
        <div className="space-y-5">
          {filtered.map((o) => (
            <OrderCard key={o.id} order={o} />
          ))}
        </div>
      ) : (
        <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No orders match your search.
        </div>
      )}
    </div>
  );
}





// // // // // import { useState, useEffect } from "react";
// // // // // import { Search, Loader2 } from "lucide-react";
// // // // // import OrderCard from "../components/modules/orders/OrderCard";
// // // // // import bookingService from "../service/bookingService";

// // // // // const filters = ["All", "CONFIRMED", "PENDING", "CANCELLED", "COMPLETED"];

// // // // // export default function Orders() {
// // // // //   const [query, setQuery] = useState("");
// // // // //   const [activeFilter, setActiveFilter] = useState("All");
// // // // //   const [bookings, setBookings] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState("");

// // // // //   const userId = localStorage.getItem('userId');

// // // // //   useEffect(() => {
// // // // //     if (userId) {
// // // // //       fetchBookings();
// // // // //     } else {
// // // // //       setError("User not logged in. Please login again.");
// // // // //       setLoading(false);
// // // // //     }
// // // // //   }, [userId]);

// // // // //   const fetchBookings = async () => {
// // // // //     setLoading(true);
// // // // //     setError("");

// // // // //     try {
// // // // //       const response = await bookingService.getBookingsByUser(userId);
// // // // //       console.log("Bookings response:", response);

// // // // //       let bookingsData = [];
// // // // //       if (Array.isArray(response)) {
// // // // //         bookingsData = response;
// // // // //       } else if (response.data && Array.isArray(response.data)) {
// // // // //         bookingsData = response.data;
// // // // //       } else if (response.success && response.data && Array.isArray(response.data)) {
// // // // //         bookingsData = response.data;
// // // // //       } else {
// // // // //         bookingsData = [];
// // // // //         setError(response.message || "No bookings found.");
// // // // //       }

// // // // //       setBookings(bookingsData);
// // // // //     } catch (err) {
// // // // //       console.error("Error fetching bookings:", err);
// // // // //       setError(err.message || "Failed to load bookings. Please try again.");
// // // // //       setBookings([]);
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //     }
// // // // //   };

// // // // //   const getStatusColor = (status) => {
// // // // //     const colors = {
// // // // //       CONFIRMED: "bg-green-100 text-green-700 border-green-200",
// // // // //       PENDING: "bg-yellow-100 text-yellow-700 border-yellow-200",
// // // // //       CANCELLED: "bg-red-100 text-red-700 border-red-200",
// // // // //       COMPLETED: "bg-blue-100 text-blue-700 border-blue-200",
// // // // //     };
// // // // //     return colors[status] || "bg-gray-100 text-gray-700 border-gray-200";
// // // // //   };

// // // // //   const getPaymentStatus = (booking) => {
// // // // //     return "Paid";
// // // // //   };

// // // // //   const filtered = bookings.filter((o) => {
// // // // //     const matchesFilter = activeFilter === "All" || o.bookingStatus === activeFilter;
// // // // //     const matchesQuery =
// // // // //       o.machineName?.toLowerCase().includes(query.toLowerCase()) ||
// // // // //       o.facilityName?.toLowerCase().includes(query.toLowerCase()) ||
// // // // //       o.bookingId?.toString().includes(query);
// // // // //     return matchesFilter && matchesQuery;
// // // // //   });

// // // // //   const activeCount = bookings.filter((o) => o.bookingStatus !== "COMPLETED" && o.bookingStatus !== "CANCELLED").length;
// // // // //   const totalSpend = bookings
// // // // //     .filter((o) => o.bookingStatus === "CONFIRMED" || o.bookingStatus === "COMPLETED")
// // // // //     .reduce((sum, o) => sum + (o.totalAmount || 0), 0);

// // // // //   if (loading) {
// // // // //     return (
// // // // //       <div className="flex items-center justify-center h-64">
// // // // //         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
// // // // //         <span className="ml-3 text-gray-600">Loading bookings...</span>
// // // // //       </div>
// // // // //     );
// // // // //   }

// // // // //   if (error) {
// // // // //     return (
// // // // //       <div>
// // // // //         <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // // // //         <p className="text-gray-600 mt-1 mb-6">
// // // // //           Track payments and delivery status for your confirmed builds.
// // // // //         </p>
// // // // //         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
// // // // //           {error}
// // // // //         </div>
// // // // //       </div>
// // // // //     );
// // // // //   }

// // // // //   return (
// // // // //     <div>
// // // // //       <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // // // //       <p className="text-gray-600 mt-1 mb-6">
// // // // //         Track your machine bookings and their status.
// // // // //       </p>

// // // // //       <div className="grid sm:grid-cols-3 gap-4 mb-6">
// // // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL BOOKINGS</p>
// // // // //           <p className="text-2xl font-extrabold text-gray-900">{bookings.length}</p>
// // // // //         </div>
// // // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE BOOKINGS</p>
// // // // //           <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
// // // // //         </div>
// // // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
// // // // //           <p className="text-2xl font-extrabold text-gray-900">
// // // // //             ₹{totalSpend.toLocaleString("en-IN")}
// // // // //           </p>
// // // // //         </div>
// // // // //       </div>

// // // // //       <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6" style={{display:"flex", justifyContent:"space-between"}}>
// // // // //         <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
// // // // //           <Search className="w-4 h-4 text-gray-400" />
// // // // //           <input
// // // // //             value={query}
// // // // //             onChange={(e) => setQuery(e.target.value)}
// // // // //             placeholder="Search by machine name, facility or booking ID..."
// // // // //             className="w-full bg-transparent text-sm focus:outline-none"
// // // // //           />
// // // // //         </div>

// // // // //         <div className="flex flex-wrap gap-2">
// // // // //           {filters.map((f) => {
// // // // //             const isActive = activeFilter === f;
// // // // //             return (
// // // // //               <button
// // // // //                 key={f}
// // // // //                 type="button"
// // // // //                 onClick={() => setActiveFilter(f)}
// // // // //                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
// // // // //                   isActive
// // // // //                     ? "bg-indigo-600 border-indigo-600 text-white"
// // // // //                     : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
// // // // //                 }`}
// // // // //               >
// // // // //                 {f}
// // // // //               </button>
// // // // //             );
// // // // //           })}
// // // // //         </div>
// // // // //       </div>

// // // // //       {filtered.length > 0 ? (
// // // // //         <div className="space-y-5">
// // // // //           {filtered.map((o) => (
// // // // //             <OrderCard 
// // // // //               key={o.bookingId} 
// // // // //               booking={o} 
// // // // //               getStatusColor={getStatusColor}
// // // // //               getPaymentStatus={getPaymentStatus}
// // // // //             />
// // // // //           ))}
// // // // //         </div>
// // // // //       ) : (
// // // // //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// // // // //           No bookings match your search.
// // // // //         </div>
// // // // //       )}
// // // // //     </div>  
// // // // //   );
// // // // // }




// // // // import { useState, useEffect, useRef } from "react";
// // // // import { Search, Loader2, ChevronDown, Calendar as CalendarIcon, X } from "lucide-react";
// // // // import OrderCard from "../components/modules/orders/OrderCard";
// // // // import bookingService from "../service/bookingService";

// // // // const statusFilters = [
// // // //   { id: "All", label: "All Status" },
// // // //   { id: "CONFIRMED", label: "Confirmed" },
// // // //   { id: "PENDING", label: "Pending" },
// // // //   { id: "CANCELLED", label: "Cancelled" },
// // // //   { id: "COMPLETED", label: "Completed" },
// // // // ];

// // // // const dateFilters = [
// // // //   { id: "all", label: "All Dates" },
// // // //   { id: "today", label: "Today" },
// // // //   { id: "yesterday", label: "Yesterday" },
// // // //   { id: "last7days", label: "Last 7 Days" },
// // // //   { id: "thisMonth", label: "This Month" },
// // // //   { id: "custom", label: "Custom Date" },
// // // // ];

// // // // export default function Orders() {
// // // //   const [query, setQuery] = useState("");
// // // //   const [activeStatusFilter, setActiveStatusFilter] = useState("All");
// // // //   const [activeDateFilter, setActiveDateFilter] = useState("today");
// // // //   const [customDate, setCustomDate] = useState("");
// // // //   const [showStatusDropdown, setShowStatusDropdown] = useState(false);
// // // //   const [showDateDropdown, setShowDateDropdown] = useState(false);
// // // //   const [showCustomDatePopup, setShowCustomDatePopup] = useState(false);
// // // //   const [bookings, setBookings] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState("");

// // // //   const statusRef = useRef(null);
// // // //   const dateRef = useRef(null);
// // // //   const customDateRef = useRef(null);

// // // //   const userId = localStorage.getItem('userId');

// // // //   // Close dropdowns when clicking outside
// // // //   useEffect(() => {
// // // //     const handleClickOutside = (event) => {
// // // //       if (statusRef.current && !statusRef.current.contains(event.target)) {
// // // //         setShowStatusDropdown(false);
// // // //       }
// // // //       if (dateRef.current && !dateRef.current.contains(event.target)) {
// // // //         setShowDateDropdown(false);
// // // //       }
// // // //       if (customDateRef.current && !customDateRef.current.contains(event.target)) {
// // // //         setShowCustomDatePopup(false);
// // // //       }
// // // //     };
// // // //     document.addEventListener("mousedown", handleClickOutside);
// // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     if (userId) {
// // // //       fetchBookings();
// // // //     } else {
// // // //       setError("User not logged in. Please login again.");
// // // //       setLoading(false);
// // // //     }
// // // //   }, [userId]);

// // // //   const fetchBookings = async () => {
// // // //     setLoading(true);
// // // //     setError("");

// // // //     try {
// // // //       const response = await bookingService.getBookingsByUser(userId);
// // // //       console.log("Bookings response:", response);

// // // //       let bookingsData = [];
// // // //       if (Array.isArray(response)) {
// // // //         bookingsData = response;
// // // //       } else if (response.data && Array.isArray(response.data)) {
// // // //         bookingsData = response.data;
// // // //       } else if (response.success && response.data && Array.isArray(response.data)) {
// // // //         bookingsData = response.data;
// // // //       } else {
// // // //         bookingsData = [];
// // // //         setError(response.message || "No bookings found.");
// // // //       }

// // // //       setBookings(bookingsData);
// // // //     } catch (err) {
// // // //       console.error("Error fetching bookings:", err);
// // // //       setError(err.message || "Failed to load bookings. Please try again.");
// // // //       setBookings([]);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const getStatusColor = (status) => {
// // // //     const colors = {
// // // //       CONFIRMED: "bg-green-100 text-green-700 border-green-200",
// // // //       PENDING: "bg-yellow-100 text-yellow-700 border-yellow-200",
// // // //       CANCELLED: "bg-red-100 text-red-700 border-red-200",
// // // //       COMPLETED: "bg-blue-100 text-blue-700 border-blue-200",
// // // //     };
// // // //     return colors[status] || "bg-gray-100 text-gray-700 border-gray-200";
// // // //   };

// // // //   const getPaymentStatus = (booking) => {
// // // //     return "Paid";
// // // //   };

// // // //   // ✅ Filter by createdAt (when booking was created)
// // // //   const filterByDate = (createdAt) => {
// // // //     if (!createdAt) return true;

// // // //     const today = new Date();
// // // //     today.setHours(0, 0, 0, 0);

// // // //     const createdDate = new Date(createdAt);
// // // //     createdDate.setHours(0, 0, 0, 0);

// // // //     switch (activeDateFilter) {
// // // //       case "all":
// // // //         return true;

// // // //       case "today":
// // // //         return createdDate.getTime() === today.getTime();

// // // //       case "yesterday": {
// // // //         const yesterday = new Date(today);
// // // //         yesterday.setDate(yesterday.getDate() - 1);
// // // //         return createdDate.getTime() === yesterday.getTime();
// // // //       }

// // // //       case "last7days": {
// // // //         const last7Days = new Date(today);
// // // //         last7Days.setDate(last7Days.getDate() - 7);
// // // //         return createdDate >= last7Days && createdDate <= today;
// // // //       }

// // // //       case "thisMonth": {
// // // //         const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
// // // //         return createdDate >= firstDayOfMonth && createdDate <= today;
// // // //       }

// // // //       case "custom": {
// // // //         if (!customDate) return true;
// // // //         const customDateObj = new Date(customDate);
// // // //         customDateObj.setHours(0, 0, 0, 0);
// // // //         return createdDate.getTime() === customDateObj.getTime();
// // // //       }

// // // //       default:
// // // //         return true;
// // // //     }
// // // //   };

// // // //   const filtered = bookings.filter((o) => {
// // // //     const matchesStatus = activeStatusFilter === "All" || o.bookingStatus === activeStatusFilter;

// // // //     const matchesQuery =
// // // //       o.machineName?.toLowerCase().includes(query.toLowerCase()) ||
// // // //       o.facilityName?.toLowerCase().includes(query.toLowerCase()) ||
// // // //       o.bookingId?.toString().includes(query);

// // // //     // ✅ Filter by createdAt
// // // //     const matchesDate = filterByDate(o.createdAt);

// // // //     return matchesStatus && matchesQuery && matchesDate;
// // // //   });

// // // //   const activeCount = bookings.filter((o) => o.bookingStatus !== "COMPLETED" && o.bookingStatus !== "CANCELLED").length;
// // // //   const totalSpend = bookings
// // // //     .filter((o) => o.bookingStatus === "CONFIRMED" || o.bookingStatus === "COMPLETED")
// // // //     .reduce((sum, o) => sum + (o.totalAmount || 0), 0);

// // // //   const getStatusLabel = () => {
// // // //     const found = statusFilters.find(f => f.id === activeStatusFilter);
// // // //     return found ? found.label : "All Status";
// // // //   };

// // // //   const getDateLabel = () => {
// // // //     const found = dateFilters.find(f => f.id === activeDateFilter);
// // // //     return found ? found.label : "All Dates";
// // // //   };

// // // //   const handleCustomDateApply = () => {
// // // //     setShowCustomDatePopup(false);
// // // //     setShowDateDropdown(false);
// // // //   };

// // // //   if (loading) {
// // // //     return (
// // // //       <div className="flex items-center justify-center h-64">
// // // //         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
// // // //         <span className="ml-3 text-gray-600">Loading bookings...</span>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   if (error) {
// // // //     return (
// // // //       <div>
// // // //         <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // // //         <p className="text-gray-600 mt-1 mb-6">
// // // //           Track payments and delivery status for your confirmed builds.
// // // //         </p>
// // // //         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
// // // //           {error}
// // // //         </div>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <div>
// // // //       <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // // //       <p className="text-gray-600 mt-1 mb-6">
// // // //         Track your machine bookings and their status.
// // // //       </p>

// // // //       <div className="grid sm:grid-cols-3 gap-4 mb-6">
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL BOOKINGS</p>
// // // //           <p className="text-2xl font-extrabold text-gray-900">{bookings.length}</p>
// // // //         </div>
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE BOOKINGS</p>
// // // //           <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
// // // //         </div>
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
// // // //           <p className="text-2xl font-extrabold text-gray-900">
// // // //             ₹{totalSpend.toLocaleString("en-IN")}
// // // //           </p>
// // // //         </div>
// // // //       </div>

// // // //       {/* Filters Bar */}
// // // //       <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
// // // //         <div className="flex flex-wrap items-center gap-3" style={{display:"flex", justifyContent:"space-between"}}>
// // // //           {/* Search */}
// // // //           <div className="flex-1 min-w-[160px] max-w-[280px] flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">
// // // //             <Search className="w-4 h-4 text-gray-400" />
// // // //             <input
// // // //               value={query}
// // // //               onChange={(e) => setQuery(e.target.value)}
// // // //               placeholder="Search bookings..."
// // // //               className="w-full bg-transparent text-sm focus:outline-none"
// // // //             />
// // // //           </div>

// // // //           <div style={{display:"flex", gap:"10px"}}>
// // // //             {/* Status Dropdown */}
// // // //             <div className="relative" ref={statusRef}>
// // // //               <button
// // // //                 onClick={() => {
// // // //                   setShowStatusDropdown(!showStatusDropdown);
// // // //                   if (showDateDropdown) setShowDateDropdown(false);
// // // //                 }}
// // // //                 className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
// // // //               >
// // // //                 {getStatusLabel()}
// // // //                 <ChevronDown className={`w-4 h-4 transition-transform ${showStatusDropdown ? "rotate-180" : ""}`} />
// // // //               </button>
// // // //               {showStatusDropdown && (
// // // //                 <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden">
// // // //                   {statusFilters.map((filter) => (
// // // //                     <button
// // // //                       key={filter.id}
// // // //                       onClick={() => {
// // // //                         setActiveStatusFilter(filter.id);
// // // //                         setShowStatusDropdown(false);
// // // //                       }}
// // // //                       className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeStatusFilter === filter.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
// // // //                         }`}
// // // //                     >
// // // //                       {filter.label}
// // // //                     </button>
// // // //                   ))}
// // // //                 </div>
// // // //               )}
// // // //             </div>

// // // //             {/* Date Dropdown */}
// // // //             <div className="relative" ref={dateRef}>
// // // //               <button
// // // //                 onClick={() => {
// // // //                   setShowDateDropdown(!showDateDropdown);
// // // //                   if (showStatusDropdown) setShowStatusDropdown(false);
// // // //                 }}
// // // //                 className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
// // // //               >
// // // //                 <CalendarIcon className="w-4 h-4" />
// // // //                 {getDateLabel()}
// // // //                 <ChevronDown className={`w-4 h-4 transition-transform ${showDateDropdown ? "rotate-180" : ""}`} />
// // // //               </button>
// // // //               {showDateDropdown && (
// // // //                 <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden">
// // // //                   {dateFilters.map((filter) => (
// // // //                     <button
// // // //                       key={filter.id}
// // // //                       onClick={() => {
// // // //                         if (filter.id === "custom") {
// // // //                           setShowCustomDatePopup(true);
// // // //                           setShowDateDropdown(false);
// // // //                           return;
// // // //                         }
// // // //                         setActiveDateFilter(filter.id);
// // // //                         setCustomDate("");
// // // //                         setShowDateDropdown(false);
// // // //                       }}
// // // //                       className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeDateFilter === filter.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
// // // //                         }`}
// // // //                     >
// // // //                       {filter.label}
// // // //                     </button>
// // // //                   ))}
// // // //                 </div>
// // // //               )}
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {/* Custom Date Popup */}
// // // //       {showCustomDatePopup && (
// // // //         <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
// // // //           <div ref={customDateRef} className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl">
// // // //             <div className="flex items-center justify-between mb-4">
// // // //               <h3 className="text-lg font-bold text-gray-900">Select Date</h3>
// // // //               <button
// // // //                 onClick={() => setShowCustomDatePopup(false)}
// // // //                 className="text-gray-400 hover:text-gray-600"
// // // //               >
// // // //                 <X className="w-5 h-5" />
// // // //               </button>
// // // //             </div>
// // // //             <input
// // // //               type="date"
// // // //               value={customDate}
// // // //               onChange={(e) => setCustomDate(e.target.value)}
// // // //               className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
// // // //             />
// // // //             <div className="flex gap-3 mt-4">
// // // //               <button
// // // //                 onClick={() => setShowCustomDatePopup(false)}
// // // //                 className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50"
// // // //               >
// // // //                 Cancel
// // // //               </button>
// // // //               <button
// // // //                 onClick={() => {
// // // //                   if (customDate) {
// // // //                     setActiveDateFilter("custom");
// // // //                     handleCustomDateApply();
// // // //                   }
// // // //                 }}
// // // //                 className="flex-1 px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
// // // //               >
// // // //                 Apply
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {filtered.length > 0 ? (
// // // //         <div className="space-y-5">
// // // //           {filtered.map((o) => (
// // // //             <OrderCard
// // // //               key={o.bookingId}
// // // //               booking={o}
// // // //               getStatusColor={getStatusColor}
// // // //               getPaymentStatus={getPaymentStatus}
// // // //             />
// // // //           ))}
// // // //         </div>
// // // //       ) : (
// // // //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// // // //           No bookings match your filters.
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }



// // // import { useState, useEffect, useRef } from "react";
// // // import { Search, Loader2, ChevronDown, Calendar as CalendarIcon, X } from "lucide-react";
// // // import OrderCard from "../components/modules/orders/OrderCard";
// // // import ExpertBookings from "../components/modules/experts/ExpertBookings";
// // // import bookingService from "../service/bookingService";

// // // const statusFilters = [
// // //   { id: "All", label: "All Status" },
// // //   { id: "CONFIRMED", label: "Confirmed" },
// // //   { id: "PENDING", label: "Pending" },
// // //   { id: "CANCELLED", label: "Cancelled" },
// // //   { id: "COMPLETED", label: "Completed" },
// // // ];

// // // const dateFilters = [
// // //   { id: "all", label: "All Dates" },
// // //   { id: "today", label: "Today" },
// // //   { id: "yesterday", label: "Yesterday" },
// // //   { id: "last7days", label: "Last 7 Days" },
// // //   { id: "thisMonth", label: "This Month" },
// // //   { id: "custom", label: "Custom Date" },
// // // ];

// // // export default function Orders() {
// // //   const [activeTab, setActiveTab] = useState("machine");
// // //   const [query, setQuery] = useState("");
// // //   const [activeStatusFilter, setActiveStatusFilter] = useState("All");
// // //   const [activeDateFilter, setActiveDateFilter] = useState("today");
// // //   const [customDate, setCustomDate] = useState("");
// // //   const [showStatusDropdown, setShowStatusDropdown] = useState(false);
// // //   const [showDateDropdown, setShowDateDropdown] = useState(false);
// // //   const [showCustomDatePopup, setShowCustomDatePopup] = useState(false);
// // //   const [bookings, setBookings] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState("");

// // //   const statusRef = useRef(null);
// // //   const dateRef = useRef(null);
// // //   const customDateRef = useRef(null);

// // //   const userId = localStorage.getItem('userId');

// // //   useEffect(() => {
// // //     const handleClickOutside = (event) => {
// // //       if (statusRef.current && !statusRef.current.contains(event.target)) {
// // //         setShowStatusDropdown(false);
// // //       }
// // //       if (dateRef.current && !dateRef.current.contains(event.target)) {
// // //         setShowDateDropdown(false);
// // //       }
// // //       if (customDateRef.current && !customDateRef.current.contains(event.target)) {
// // //         setShowCustomDatePopup(false);
// // //       }
// // //     };
// // //     document.addEventListener("mousedown", handleClickOutside);
// // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // //   }, []);

// // //   useEffect(() => {
// // //     if (userId) {
// // //       fetchBookings();
// // //     } else {
// // //       setError("User not logged in. Please login again.");
// // //       setLoading(false);
// // //     }
// // //   }, [userId]);

// // //   const fetchBookings = async () => {
// // //     setLoading(true);
// // //     setError("");

// // //     try {
// // //       const response = await bookingService.getBookingsByUser(userId);
// // //       console.log("Bookings response:", response);

// // //       let bookingsData = [];
// // //       if (Array.isArray(response)) {
// // //         bookingsData = response;
// // //       } else if (response.data && Array.isArray(response.data)) {
// // //         bookingsData = response.data;
// // //       } else if (response.success && response.data && Array.isArray(response.data)) {
// // //         bookingsData = response.data;
// // //       } else {
// // //         bookingsData = [];
// // //         setError(response.message || "No bookings found.");
// // //       }

// // //       setBookings(bookingsData);
// // //     } catch (err) {
// // //       console.error("Error fetching bookings:", err);
// // //       setError(err.message || "Failed to load bookings. Please try again.");
// // //       setBookings([]);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const getStatusColor = (status) => {
// // //     const colors = {
// // //       CONFIRMED: "bg-green-100 text-green-700 border-green-200",
// // //       PENDING: "bg-yellow-100 text-yellow-700 border-yellow-200",
// // //       CANCELLED: "bg-red-100 text-red-700 border-red-200",
// // //       COMPLETED: "bg-blue-100 text-blue-700 border-blue-200",
// // //     };
// // //     return colors[status] || "bg-gray-100 text-gray-700 border-gray-200";
// // //   };

// // //   const getPaymentStatus = (booking) => {
// // //     return "Paid";
// // //   };

// // //   const filterByDate = (createdAt) => {
// // //     if (!createdAt) return true;

// // //     const today = new Date();
// // //     today.setHours(0, 0, 0, 0);

// // //     const createdDate = new Date(createdAt);
// // //     createdDate.setHours(0, 0, 0, 0);

// // //     switch (activeDateFilter) {
// // //       case "all":
// // //         return true;
// // //       case "today":
// // //         return createdDate.getTime() === today.getTime();
// // //       case "yesterday": {
// // //         const yesterday = new Date(today);
// // //         yesterday.setDate(yesterday.getDate() - 1);
// // //         return createdDate.getTime() === yesterday.getTime();
// // //       }
// // //       case "last7days": {
// // //         const last7Days = new Date(today);
// // //         last7Days.setDate(last7Days.getDate() - 7);
// // //         return createdDate >= last7Days && createdDate <= today;
// // //       }
// // //       case "thisMonth": {
// // //         const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
// // //         return createdDate >= firstDayOfMonth && createdDate <= today;
// // //       }
// // //       case "custom": {
// // //         if (!customDate) return true;
// // //         const customDateObj = new Date(customDate);
// // //         customDateObj.setHours(0, 0, 0, 0);
// // //         return createdDate.getTime() === customDateObj.getTime();
// // //       }
// // //       default:
// // //         return true;
// // //     }
// // //   };

// // //   const filtered = bookings.filter((o) => {
// // //     const matchesStatus = activeStatusFilter === "All" || o.bookingStatus === activeStatusFilter;

// // //     const matchesQuery =
// // //       o.machineName?.toLowerCase().includes(query.toLowerCase()) ||
// // //       o.facilityName?.toLowerCase().includes(query.toLowerCase()) ||
// // //       o.bookingId?.toString().includes(query);

// // //     const matchesDate = filterByDate(o.createdAt);

// // //     return matchesStatus && matchesQuery && matchesDate;
// // //   });

// // //   const activeCount = bookings.filter((o) => o.bookingStatus !== "COMPLETED" && o.bookingStatus !== "CANCELLED").length;
// // //   const totalSpend = bookings
// // //     .filter((o) => o.bookingStatus === "CONFIRMED" || o.bookingStatus === "COMPLETED")
// // //     .reduce((sum, o) => sum + (o.totalAmount || 0), 0);

// // //   const getStatusLabel = () => {
// // //     const found = statusFilters.find(f => f.id === activeStatusFilter);
// // //     return found ? found.label : "All Status";
// // //   };

// // //   const getDateLabel = () => {
// // //     const found = dateFilters.find(f => f.id === activeDateFilter);
// // //     return found ? found.label : "All Dates";
// // //   };

// // //   const handleCustomDateApply = () => {
// // //     setShowCustomDatePopup(false);
// // //     setShowDateDropdown(false);
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <div className="flex items-center justify-center h-64">
// // //         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
// // //         <span className="ml-3 text-gray-600">Loading bookings...</span>
// // //       </div>
// // //     );
// // //   }

// // //   if (error) {
// // //     return (
// // //       <div>
// // //         <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // //         <p className="text-gray-600 mt-1 mb-6">
// // //           Track payments and delivery status for your confirmed builds.
// // //         </p>
// // //         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
// // //           {error}
// // //         </div>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <div>


// // //       {/* Tabs */}
// // //       <div className="flex gap-1 bg-gray-100 rounded-xl p-1 mb-6 w-fit">
// // //         <button
// // //           onClick={() => setActiveTab("machine")}
// // //           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${activeTab === "machine"
// // //             ? "bg-white text-indigo-600 shadow-sm"
// // //             : "text-gray-500 hover:text-gray-700"
// // //             }`}
// // //         >
// // //           Machine Bookings
// // //           <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${activeTab === "machine"
// // //             ? "bg-indigo-100 text-indigo-600"
// // //             : "bg-gray-200 text-gray-500"
// // //             }`}>
// // //             {bookings.length}
// // //           </span>
// // //         </button>
// // //         <button
// // //           onClick={() => setActiveTab("expert")}
// // //           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${activeTab === "expert"
// // //             ? "bg-white text-indigo-600 shadow-sm"
// // //             : "text-gray-500 hover:text-gray-700"
// // //             }`}
// // //         >
// // //           Expert Bookings
// // //         </button>
// // //       </div>

// // //       {/* Machine Bookings Tab */}
// // //       {activeTab === "machine" && (

// // //         <>
// // //           <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
// // //           <p className="text-gray-600 mt-1 mb-6">
// // //             Track your machine bookings and their status.
// // //           </p>
// // //           <>
// // //             <div className="grid sm:grid-cols-3 gap-4 mb-6">
// // //               <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // //                 <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL BOOKINGS</p>
// // //                 <p className="text-2xl font-extrabold text-gray-900">{bookings.length}</p>
// // //               </div>
// // //               <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // //                 <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE BOOKINGS</p>
// // //                 <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
// // //               </div>
// // //               <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // //                 <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
// // //                 <p className="text-2xl font-extrabold text-gray-900">
// // //                   ₹{totalSpend.toLocaleString("en-IN")}
// // //                 </p>
// // //               </div>
// // //             </div>

// // //             {/* Filters Bar */}
// // //             <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
// // //               <div className="flex flex-wrap items-center gap-3" style={{ display: "flex", justifyContent: "space-between" }}>
// // //                 <div className="flex-1 min-w-[160px] max-w-[280px] flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">
// // //                   <Search className="w-4 h-4 text-gray-400" />
// // //                   <input
// // //                     value={query}
// // //                     onChange={(e) => setQuery(e.target.value)}
// // //                     placeholder="Search bookings..."
// // //                     className="w-full bg-transparent text-sm focus:outline-none"
// // //                   />
// // //                 </div>

// // //                 <div style={{ display: "flex", gap: "10px" }}>
// // //                   <div className="relative" ref={statusRef}>
// // //                     <button
// // //                       onClick={() => {
// // //                         setShowStatusDropdown(!showStatusDropdown);
// // //                         if (showDateDropdown) setShowDateDropdown(false);
// // //                       }}
// // //                       className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
// // //                     >
// // //                       {getStatusLabel()}
// // //                       <ChevronDown className={`w-4 h-4 transition-transform ${showStatusDropdown ? "rotate-180" : ""}`} />
// // //                     </button>
// // //                     {showStatusDropdown && (
// // //                       <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden">
// // //                         {statusFilters.map((filter) => (
// // //                           <button
// // //                             key={filter.id}
// // //                             onClick={() => {
// // //                               setActiveStatusFilter(filter.id);
// // //                               setShowStatusDropdown(false);
// // //                             }}
// // //                             className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeStatusFilter === filter.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
// // //                               }`}
// // //                           >
// // //                             {filter.label}
// // //                           </button>
// // //                         ))}
// // //                       </div>
// // //                     )}
// // //                   </div>

// // //                   <div className="relative" ref={dateRef}>
// // //                     <button
// // //                       onClick={() => {
// // //                         setShowDateDropdown(!showDateDropdown);
// // //                         if (showStatusDropdown) setShowStatusDropdown(false);
// // //                       }}
// // //                       className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
// // //                     >
// // //                       <CalendarIcon className="w-4 h-4" />
// // //                       {getDateLabel()}
// // //                       <ChevronDown className={`w-4 h-4 transition-transform ${showDateDropdown ? "rotate-180" : ""}`} />
// // //                     </button>
// // //                     {showDateDropdown && (
// // //                       <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden">
// // //                         {dateFilters.map((filter) => (
// // //                           <button
// // //                             key={filter.id}
// // //                             onClick={() => {
// // //                               if (filter.id === "custom") {
// // //                                 setShowCustomDatePopup(true);
// // //                                 setShowDateDropdown(false);
// // //                                 return;
// // //                               }
// // //                               setActiveDateFilter(filter.id);
// // //                               setCustomDate("");
// // //                               setShowDateDropdown(false);
// // //                             }}
// // //                             className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeDateFilter === filter.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
// // //                               }`}
// // //                           >
// // //                             {filter.label}
// // //                           </button>
// // //                         ))}
// // //                       </div>
// // //                     )}
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* Custom Date Popup */}
// // //             {showCustomDatePopup && (
// // //               <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
// // //                 <div ref={customDateRef} className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl">
// // //                   <div className="flex items-center justify-between mb-4">
// // //                     <h3 className="text-lg font-bold text-gray-900">Select Date</h3>
// // //                     <button
// // //                       onClick={() => setShowCustomDatePopup(false)}
// // //                       className="text-gray-400 hover:text-gray-600"
// // //                     >
// // //                       <X className="w-5 h-5" />
// // //                     </button>
// // //                   </div>
// // //                   <input
// // //                     type="date"
// // //                     value={customDate}
// // //                     onChange={(e) => setCustomDate(e.target.value)}
// // //                     className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
// // //                   />
// // //                   <div className="flex gap-3 mt-4">
// // //                     <button
// // //                       onClick={() => setShowCustomDatePopup(false)}
// // //                       className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50"
// // //                     >
// // //                       Cancel
// // //                     </button>
// // //                     <button
// // //                       onClick={() => {
// // //                         if (customDate) {
// // //                           setActiveDateFilter("custom");
// // //                           handleCustomDateApply();
// // //                         }
// // //                       }}
// // //                       className="flex-1 px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
// // //                     >
// // //                       Apply
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             )}

// // //             {filtered.length > 0 ? (
// // //               <div className="space-y-5">
// // //                 {filtered.map((o) => (
// // //                   <OrderCard
// // //                     key={o.bookingId}
// // //                     booking={o}
// // //                     getStatusColor={getStatusColor}
// // //                     getPaymentStatus={getPaymentStatus}
// // //                   />
// // //                 ))}
// // //               </div>
// // //             ) : (
// // //               <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// // //                 No bookings match your filters.
// // //               </div>
// // //             )}
// // //           </>
// // //         </>
// // //       )}

// // //       {/* Expert Bookings Tab */}
// // //       {activeTab === "expert" && <ExpertBookings />}
// // //     </div>
// // //   );
// // // }



// import { useState } from "react";
// import { Search, Calendar, Clock, User, Star } from "lucide-react";
// import OrderCard from "../components/modules/orders/OrderCard";
// import ordersData from "../data/ordersData";

// const filters = ["All", "Awaiting Payment", "In Production", "Quality Inspection", "Delivered"];

// // Static expert bookings data
// const expertBookingsData = [
//   {
//     id: "EXP-001",
//     expertName: "Dr. Ananya Reddy",
//     specialty: "Additive Manufacturing",
//     institution: "IIT Tirupati",
//     rating: 4.9,
//     bookingDate: "2026-07-24",
//     bookingTime: "10:30 AM",
//     duration: "60 min",
//     amount: 3000,
//     status: "Confirmed",
//     statusColor: "bg-green-100 text-green-700",
//   },
//   {
//     id: "EXP-002",
//     expertName: "Prof. Karthik Iyer",
//     specialty: "Robotics & Mechatronics",
//     institution: "IIIT Sri City",
//     rating: 4.8,
//     bookingDate: "2026-07-25",
//     bookingTime: "02:00 PM",
//     duration: "30 min",
//     amount: 1800,
//     status: "Pending",
//     statusColor: "bg-yellow-100 text-yellow-700",
//   },
//   {
//     id: "EXP-003",
//     expertName: "Meera Sundaram",
//     specialty: "PCB & Embedded Design",
//     institution: "APIC Visakhapatnam",
//     rating: 4.7,
//     bookingDate: "2026-07-26",
//     bookingTime: "11:00 AM",
//     duration: "90 min",
//     amount: 3600,
//     status: "Completed",
//     statusColor: "bg-blue-100 text-blue-700",
//   },
//   {
//     id: "EXP-004",
//     expertName: "Rahul Varma",
//     specialty: "EV Powertrain",
//     institution: "Ashok Leyland R&D",
//     rating: 4.9,
//     bookingDate: "2026-07-27",
//     bookingTime: "04:30 PM",
//     duration: "45 min",
//     amount: 2200,
//     status: "Cancelled",
//     statusColor: "bg-red-100 text-red-700",
//   },
// ];

// // Expert booking filter options
// const expertFilters = ["All", "Confirmed", "Pending", "Completed", "Cancelled"];

// export default function Orders() {
//   const [activeTab, setActiveTab] = useState("machine"); // "machine" | "expert"
//   const [query, setQuery] = useState("");
//   const [activeFilter, setActiveFilter] = useState("All");
//   const [expertQuery, setExpertQuery] = useState("");
//   const [activeExpertFilter, setActiveExpertFilter] = useState("All");

//   // Filter machine orders
//   const filteredMachine = ordersData.filter((o) => {
//     const matchesFilter = activeFilter === "All" || o.deliveryStatus === activeFilter;
//     const matchesQuery =
//       o.projectTitle?.toLowerCase().includes(query.toLowerCase()) ||
//       o.id?.toLowerCase().includes(query.toLowerCase());
//     return matchesFilter && matchesQuery;
//   });

//   // Filter expert bookings
//   const filteredExpert = expertBookingsData.filter((b) => {
//     const matchesFilter = activeExpertFilter === "All" || b.status === activeExpertFilter;
//     const matchesQuery =
//       b.expertName?.toLowerCase().includes(expertQuery.toLowerCase()) ||
//       b.specialty?.toLowerCase().includes(expertQuery.toLowerCase()) ||
//       b.id?.toLowerCase().includes(expertQuery.toLowerCase());
//     return matchesFilter && matchesQuery;
//   });

//   const activeCount = ordersData.filter((o) => o.deliveryStatus !== "Delivered").length;
//   const totalSpend = ordersData
//     .filter((o) => o.paymentStatus === "Paid")
//     .reduce((sum, o) => sum + o.amount, 0);

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">Orders</h1>
//       <p className="text-gray-600 mt-1 mb-6">
//         Track payments and delivery status for your confirmed builds.
//       </p>

//       {/* Tabs */}
//       <div className="flex gap-1 bg-gray-100 rounded-xl p-1 mb-6 w-fit">
//         <button
//           onClick={() => setActiveTab("machine")}
//           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${
//             activeTab === "machine"
//               ? "bg-white text-indigo-600 shadow-sm"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Machine Orders
//           <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
//             activeTab === "machine" 
//               ? "bg-indigo-100 text-indigo-600" 
//               : "bg-gray-200 text-gray-500"
//           }`}>
//             {ordersData.length}
//           </span>
//         </button>
//         <button
//           onClick={() => setActiveTab("expert")}
//           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${
//             activeTab === "expert"
//               ? "bg-white text-indigo-600 shadow-sm"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Expert Bookings
//           <span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
//             activeTab === "expert" 
//               ? "bg-indigo-100 text-indigo-600" 
//               : "bg-gray-200 text-gray-500"
//           }`}>
//             {expertBookingsData.length}
//           </span>
//         </button>
//       </div>

//       {/* Machine Orders Tab */}
//       {activeTab === "machine" && (
//         <>
//           {/* Summary stats */}
//           <div className="grid sm:grid-cols-3 gap-4 mb-6">
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL ORDERS</p>
//               <p className="text-2xl font-extrabold text-gray-900">{ordersData.length}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE ORDERS</p>
//               <p className="text-2xl font-extrabold text-blue-600">{activeCount}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
//               <p className="text-2xl font-extrabold text-gray-900">
//                 ₹{totalSpend.toLocaleString("en-IN")}
//               </p>
//             </div>
//           </div>

//           {/* Search + filters */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6" style={{display:"flex", justifyContent:"space-between"}}>
//             <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
//               <Search className="w-4 h-4 text-gray-400" />
//               <input
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 placeholder="Search by project name or order ID..."
//                 className="w-full bg-transparent text-sm focus:outline-none"
//               />
//             </div>

//             <div className="flex flex-wrap gap-2">
//               {filters.map((f) => {
//                 const isActive = activeFilter === f;
//                 return (
//                   <button
//                     key={f}
//                     type="button"
//                     onClick={() => setActiveFilter(f)}
//                     className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
//                       isActive
//                         ? "bg-indigo-600 border-indigo-600 text-white"
//                         : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//                     }`}
//                   >
//                     {f}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* List */}
//           {filteredMachine.length > 0 ? (
//             <div className="space-y-5">
//               {filteredMachine.map((o) => (
//                 <OrderCard key={o.id} order={o} />
//               ))}
//             </div>
//           ) : (
//             <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//               No orders match your search.
//             </div>
//           )}
//         </>
//       )}

//       {/* Expert Bookings Tab */}
//       {activeTab === "expert" && (
//         <>
//           {/* Expert booking stats */}
//           <div className="grid sm:grid-cols-3 gap-4 mb-6">
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL BOOKINGS</p>
//               <p className="text-2xl font-extrabold text-gray-900">{expertBookingsData.length}</p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">ACTIVE BOOKINGS</p>
//               <p className="text-2xl font-extrabold text-blue-600">
//                 {expertBookingsData.filter(b => b.status === "Confirmed" || b.status === "Pending").length}
//               </p>
//             </div>
//             <div className="bg-white border border-gray-100 rounded-2xl p-5">
//               <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPEND</p>
//               <p className="text-2xl font-extrabold text-gray-900">
//                 ₹{expertBookingsData.reduce((sum, b) => sum + b.amount, 0).toLocaleString("en-IN")}
//               </p>
//             </div>
//           </div>

//           {/* Search + filters */}
//           <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6" style={{display:"flex", justifyContent:"space-between"}}>
//             <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
//               <Search className="w-4 h-4 text-gray-400" />
//               <input
//                 value={expertQuery}
//                 onChange={(e) => setExpertQuery(e.target.value)}
//                 placeholder="Search by expert name, specialty or booking ID..."
//                 className="w-full bg-transparent text-sm focus:outline-none"
//               />
//             </div>

//             <div className="flex flex-wrap gap-2">
//               {expertFilters.map((f) => {
//                 const isActive = activeExpertFilter === f;
//                 return (
//                   <button
//                     key={f}
//                     type="button"
//                     onClick={() => setActiveExpertFilter(f)}
//                     className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
//                       isActive
//                         ? "bg-indigo-600 border-indigo-600 text-white"
//                         : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//                     }`}
//                   >
//                     {f}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Expert Booking Cards */}
//           {filteredExpert.length > 0 ? (
//             <div className="space-y-5">
//               {filteredExpert.map((booking) => (
//                 <div key={booking.id} className="border border-gray-100 rounded-xl p-5 hover:shadow-md transition-shadow">
//                   <div className="flex items-start justify-between flex-wrap gap-3 mb-4">
//                     <div className="flex items-start gap-3">
//                       <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-sm font-bold flex items-center justify-center shrink-0">
//                         {booking.expertName.charAt(0)}
//                       </div>
//                       <div>
//                         <h3 className="font-bold text-gray-900">{booking.expertName}</h3>
//                         <p className="text-sm text-gray-500">{booking.specialty}</p>
//                         <p className="text-xs text-gray-400">{booking.institution}</p>
//                       </div>
//                     </div>
//                     <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${booking.statusColor}`}>
//                       {booking.status}
//                     </span>
//                   </div>

//                   <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mb-4 text-sm">
//                     <div>
//                       <p className="text-gray-500 text-xs mb-0.5">Booking ID</p>
//                       <p className="font-medium text-gray-900">{booking.id}</p>
//                     </div>
//                     <div>
//                       <p className="text-gray-500 text-xs mb-0.5">Date</p>
//                       <p className="font-medium text-gray-900">{booking.bookingDate}</p>
//                     </div>
//                     <div>
//                       <p className="text-gray-500 text-xs mb-0.5">Time</p>
//                       <p className="font-medium text-gray-900">{booking.bookingTime}</p>
//                     </div>
//                     <div>
//                       <p className="text-gray-500 text-xs mb-0.5">Duration</p>
//                       <p className="font-medium text-gray-900">{booking.duration}</p>
//                     </div>
//                     <div>
//                       <p className="text-gray-500 text-xs mb-0.5">Rating</p>
//                       <p className="flex items-center gap-1 font-medium text-gray-900">
//                         <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
//                         {booking.rating}
//                       </p>
//                     </div>
//                   </div>

//                   <div className="flex items-center justify-between pt-4 border-t border-gray-100">
//                     <span className="text-sm font-medium text-gray-600">
//                       Amount: <span className="font-bold text-indigo-600">₹{booking.amount.toLocaleString("en-IN")}</span>
//                     </span>

//                     {booking.status === "Pending" ? (
//                       <button className="bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-5 py-2 rounded-xl hover:opacity-90 transition">
//                         Pay Now
//                       </button>
//                     ) : (
//                       <button className="border border-gray-200 text-sm font-semibold px-5 py-2 rounded-xl hover:bg-gray-50 transition">
//                         View Details
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//               No expert bookings match your search.
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }